import React, {useState, useLayoutEffect, useEffect} from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import { Spin } from 'antd';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

  const contentStyle = {
    padding: 50,
    background: 'rgba(0, 0, 0, 0)',
    borderRadius: 4,
    color: '#008a80'
  };


const Terms = () => {
    const [file, setFile] = useState('./termsofuse.pdf');
    const [loading, setLoading] = useState(true);
    const [numOfPages, setNumOfPages] = useState();
    const [width, setWidth] = useState(window.innerWidth);

    const onDocumentLoad = ({numPages}) => setNumOfPages(numPages);

    useEffect(() => {
        function updateSize() {
          setWidth(window.innerWidth);
        };
        window.addEventListener('resize', updateSize);
        return () => window.removeEventListener('resize', updateSize);
    }, []);

  return (

    <>
    {loading && (
        <div style={{height: '100vh', width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <Spin size='large' spinning={true} style={{color: '#008a80'}} tip='Loading'><div style={contentStyle} /></Spin>
        </div>
    )}

    <div style={{display: loading ? 'none' : 'block', overflow: 'hidden'}}>
       <Document file={file} onLoadSuccess={onDocumentLoad}>

       {Array.from(new Array(numOfPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={width}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                customTextRenderer={false}
                onRenderSuccess={() => {
                    if(index == numOfPages-1) setLoading(false);
                }}
              />
        ))}
       </Document>
    </div>

    </>
  )
}

export default Terms